import React, { useState, useEffect, useRef } from "react";
import "./MobileVerification.css";
import { Redirect } from "react-router";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as AppUrls from "../../constants/AppUrls";
import * as Constants from "../../constants/Constants";
import { useTranslation } from "react-i18next";
import * as utils from "../../global/utils";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "../../store/actionTypes";
import * as Helpers from "../../global/Helpers";
import i18next from "i18next";
import "react-simple-keyboard/build/css/index.css";
import { otpSessionId } from "./Login.js"; 
const MobileVerification = (props) => {
  const { t, i18n } = useTranslation();
  const [deviceName] = useState("");
  const [redirect, setRedirect] = useState(null);
  const dispatch = useDispatch();
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);
  const abortController = new AbortController();

  useEffect(() => {
    CallCheckApproveNotificationVasco();
    const interval = setInterval(() => {
      CallCheckApproveNotificationVasco();
    }, 10000);

    const timeout = setTimeout(() => {
      clearInterval(interval);
      callLogOff();
    }, 300000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  function CallUpdateNotificationVascoDetails() {
    var param = {
      IS_VERIFAY: "N",
    };

    let UpdateNotificationVascoDetailsResponse =
      utils.UpdateNotificationVascoDetails(param);
    UpdateNotificationVascoDetailsResponse.then((response) => {
      if (response.status === 200) {
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  function CallCheckApproveNotificationVasco(e) {
    // var passwordToOTp =
    //   localStorage.getItem("passwordToOTp") === "false"
    //     ? ""
    //     : localStorage.getItem("passwordToOTp");
    // var isAuthorizeOnly =
    //   localStorage.getItem("passwordToOTp") === "false" ? "Y" : "N";

      const encPass = otpSessionId ? otpSessionId.value : ""
    var passwordToOTp =
      encPass === "false"
        ? ""
        : encPass;
    var isAuthorizeOnly =
     encPass === "false" ? "Y" : "N";

    var response = utils.CheckApproveNotificationVasco(
      localStorage.getItem("username"),
      localStorage.getItem("WebCode"),
      "",
      passwordToOTp,
      "",
      "",
      isAuthorizeOnly,
      "N"
    );

    response
      .then((response) => {
        // setVisible(false);

        let responseJson = response.data;
        let webcode = responseJson["WebCode"];
        let isFirstLoggedIn = response.data["IsFirstLogin"]; //localStorage.getItem("isFirstLoggedIn");

        if (
          webcode !== undefined &&
          webcode !== null &&
          webcode !== "" &&
          webcode !== "-1" &&
          responseJson["Status"] === "0"
        ) {
          if (isFirstLoggedIn === "Y") {
            localStorage.setItem("WebCode", webcode);
            localStorage.setItem("loginFirst", true);
            localStorage.setItem("validValue", "");
            localStorage.setItem(
              "isTermsAndConditions",
              response.data["isTermsAndConditions"]
            );
            localStorage.setItem("UpdateInfo", response.data["UpdateInfo"]);

            localStorage.setItem(
              "ExpiredDocument",
              response.data["isExpiredDocument"]
            );
            localStorage.setItem("isIndividual", response.data["isIndividual"]);
            localStorage.setItem("user", JSON.stringify(response.data));
            localStorage.setItem("IsNormalLogin", true);

            getUserSettings();
            setRedirect(AppUrls.changePassword);

            return;
          } else {
            Helpers.successNotify(t("Successful_Login!"), i18next.language);
            localStorage.setItem("WebCode", webcode);
            localStorage.setItem("loginFirst", true);
            localStorage.setItem(
              "isTermsAndConditions",
              response.data["isTermsAndConditions"]
            );
            localStorage.setItem("UpdateInfo", response.data["UpdateInfo"]);
            getUserSettings();
            localStorage.setItem("user", JSON.stringify(response.data));

            localStorage.setItem(
              "ExpiredDocument",
              response.data["isExpiredDocument"]
            );
            localStorage.setItem("isIndividual", response.data["isIndividual"]);
            localStorage.setItem("IsNormalLogin", true);
            clearInterval(intervalRef.current);
            clearTimeout(timeoutRef.current);
            setRedirect(AppUrls.trading);
          }
        } else {
          //console.log("error", responseJson["Status"]);
        }
      })
      .catch((error) => {
        // setVisible(false);
        console.log("error", error);
        Helpers.errorNotify(error.message, i18n.language);
      });
  }

  const getUserSettings = () => {
    let response = utils.GetSettingWorkSpaceByUserID();
    response
      .then((response) => {
        //
        let data = response.data[0];
        if (
          data.WorkSpaceSettings !== undefined &&
          data.WorkSpaceSettings !== null &&
          data.WorkSpaceSettings !== ""
        ) {
          var res = JSON.parse(data.WorkSpaceSettings);

          localStorage.setItem("selectedProfile", res.selectedProfile);
          localStorage.setItem("theme", res.theme);
          localStorage.setItem("UserSettings", data.WorkSpaceSettings);

          dispatch({
            type: actions.SELECT_PREFERRED_SYMBOL,
            payload: {
              PreferredSymbol: res.PreferredSymbol,
            },
          });

          dispatch({
            type: actions.SELECT_PREFERRED_EXCHANGE,
            payload: {
              PreferredExchange: res.PreferredExchange,
            },
          });

          dispatch({
            type: actions.UPDATE_ENABLE_EXPAND_ROW,
            payload: {
              EnableExpandRow: res.expandRow === "Y" ? true : false,
            },
          });

          dispatch({
            type: actions.ENABLE_TRADE_TICKER,
            payload: {
              EnableTradeTicker: res.tradeTicker === "Y" ? true : false,
            },
          });

          dispatch({
            type: actions.ENABLE_ROUND_TICKER,
            payload: {
              EnableRoundTicker: res.RoundTicker === "Y" ? true : false,
            },
          });
          saveSettings(data);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  function saveSettings(data) {
    var res = JSON.parse(data.WorkSpaceSettings);
    let LanguageSelectedFromLogin = localStorage.getItem(
      "LanguageSelectedFromLogin"
    );
    let isLanguageSelectedFromLogin = localStorage.getItem(
      "isLanguageSelectedFromLogin"
    );
    var lang = "";
    if (isLanguageSelectedFromLogin === "true")
      lang = LanguageSelectedFromLogin;
    else lang = res.lang;
    let settings = {
      lang: lang,
      theme: res.theme,
      //theme: '',
      expandRow: res.expandRow,
      PreferredSymbol: res.PreferredSymbol,
      PreferredExchange: res.PreferredExchange,
      selectedProfile: res.selectedProfile,
      tradeTicker: res.tradeTicker,
      RoundTicker: res.RoundTicker,
    };

    if (data !== undefined && data !== null) {
      let postdata = {
        profileUniqueID: data.profileUniqueID,
        ProfileID: data.ProfileID,
        ProfileName: data.ProfileName,
        ProfileNameAr: data.ProfileNameAr,
        ProfileSettings: data.ProfileSettings,
        WorkSpaceSettings: JSON.stringify(settings),
        WebCode: localStorage.getItem("WebCode"),
      };
      var updateWorkSpaceSettings = utils.UpdateUserProfileSettings(postdata);
      updateWorkSpaceSettings
        .then((response) => {
          if (response.data) {
            // console.log("Settings Successfully Updated");
            // this.props.setUserSettings(settings)
            localStorage.setItem("UserSettings", JSON.stringify(settings));

            if (i18n.language === "ar" && settings.lang === "en")
              props.changeLanguageNew();
            else if (i18n.language === "en" && settings.lang === "ar")
              props.changeLanguageNew();
          } else {
            console.log(
              "Unsuccessfull Update Settings, please contact Administrator"
            );
          }
        })
        .finally(() => {
          if (abortController) abortController.abort();
        })
        .catch((error) => {
          console.log(
            "Unsuccessfull Update Settings, please contact Administrator"
          );
          if (abortController) abortController.abort();
        });
    }
  }

  const callLogOff = () => {
    //
    // props.setIsLoaderVisible(true);
    //console.log("logging out...");
    let logOffResponse = utils.logOff();
    logOffResponse
      .then((response) => {
        // props.setIsLoaderVisible(false);
        //console.log("Logged Off", response)
        if (response.status === 200) {
          localStorage.removeItem("user");
          localStorage.removeItem("ExpiredDocument");
          let UserName = localStorage.getItem("username");
          let RememberMe = localStorage.getItem("isRememberMe");
          let language = localStorage.getItem("language");

          let Comapnyname = localStorage.getItem(
            Constants.localStorageConstants.company_name
          );
          var prev = Helpers.getPreviousConfig();

          if (RememberMe === "true") {
            localStorage.clear();
            localStorage.setItem("isRememberMe", true);
            localStorage.setItem("username", UserName);
            localStorage.setItem("language", language);

            localStorage.setItem(
              Constants.localStorageConstants.company_name,
              Comapnyname
            );
          } else {
            localStorage.clear();
            localStorage.setItem("language", language);

            localStorage.setItem(
              Constants.localStorageConstants.company_name,
              Comapnyname
            );
          }
          Helpers.SetpreviosConfig(prev);
          setRedirect(AppUrls.login);
          //   setState({ redirect: AppUrls.login }, () => {
          //     disconnectSignalr();
          //   });
        } else {
                  setRedirect(AppUrls.login);

        }
      })
      .catch((error) => {
        setRedirect(AppUrls.login);
        //props.setIsLoaderVisible(false);
        //console.log("error", error);
      });
  };

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div className="two-step-container">
      <div className="two-step-header">
        <h1>{t("Step Verification")}</h1>
        <div className="divider"></div>
        <h5 className="help-text">
          {t(
            "Please verify this login request on your registered mobile device"
          )}
        </h5>
        {/* <div className="user-email">{localStorage.getItem("username")}</div>
        <div className="divider"></div> */}
      </div>

      {/* <div className="verification-method">
        <h2>
          {t("Please approve the login request on your mobile")} {deviceName}
        </h2>
        <p>
          {t("A notification has been sent to your mobile device.")} 
          {t("Open the trading app and tap")} <strong>{t("Yes")}</strong>{" "}
          {t("on the prompt to verify that it's you.")}
        </p>

     
      </div> */}

      <div className="alternative-options ">
        <button
          className="text-button WelcomeMessageDiv"
          onClick={(event) => {
            // event.preventDefault();
            // callLogOff();
             localStorage.removeItem("user");
          localStorage.removeItem("ExpiredDocument");
             setRedirect(AppUrls.login);
          }}
        >
          {t("cancelForgotPassword")}
        </button>
      </div>
    </div>
  );
};

export default MobileVerification;
